export default (cultures?: { [key: string]: any }, translations?: any) => {
    const result: any[] = [];

    if (typeof cultures !== "undefined") {
        for (const key in cultures) {
            result.push({
                lang: key.toLowerCase(),
                label: translations[`LANGUAGES.LANGUAGE_${key.toUpperCase()}`] || key.toUpperCase(),
                link: cultures[key],
            });
        }
    }

    return result;
};
